import React, { createContext, useContext, useState, useEffect } from 'react';
import { node } from 'prop-types';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({
    homeHero: true,
    homeFeatured: true,
    pageBuilder: true,
  });
  const [startTime] = useState(Date.now());
  const [minimumTimeElapsed, setMinimumTimeElapsed] = useState(false);

  // Ensure loading screen shows for at least 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setMinimumTimeElapsed(true);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const setLoadingComplete = (component) => {
    setLoadingStates(prev => ({
      ...prev,
      [component]: false,
    }));
  };

  const allComponentsLoaded = Object.values(loadingStates).every(state => state === false);
  const isLoading = !allComponentsLoaded || !minimumTimeElapsed;

  return (
    <LoadingContext.Provider 
      value={{
        loadingStates,
        setLoadingComplete,
        isLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: node.isRequired,
};